import { useRef, useState } from "react";
import AgendaMainScreen from "../agenda/AgendaMainScreen.tsx";
import ChecklistsScreen from "../modules/checklists/ChecklistsScreen.tsx";
import OrdersReceptionScreen from "../modules/ordering/OrdersReceptionScreen.tsx";
import type { OrdersReceptionApi } from "../modules/ordering/orderingApi.ts";

type Screen = "Agenda" | "Checklists" | "Réception des commandes";
const screens: Screen[] = ["Agenda", "Checklists", "Réception des commandes"];

const ScreenSwitcher = ({
  userId,
  ordersApi,
}: {
  userId: string;
  ordersApi: OrdersReceptionApi;
}) => {
  const [screen, setScreen] = useState<Screen>("Agenda");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasOpenedReception, setHasOpenedReception] = useState(false);
  const menuRef = useRef<HTMLDialogElement>(null);
  const selectScreen = (next: Screen) => {
    if (next === "Réception des commandes") setHasOpenedReception(true);
    setScreen(next);
    menuRef.current?.close();
  };
  return (
    <div className="pwa-main">
      <header className="pwa-menu-header">
        <button
          type="button"
          aria-label="Ouvrir le menu principal"
          aria-expanded={isMenuOpen}
          aria-controls="pwa-main-menu"
          className="flex min-h-11 items-center gap-2 rounded px-3 font-semibold"
          onClick={() => {
            menuRef.current?.showModal();
            setIsMenuOpen(true);
          }}
        >
          <span aria-hidden="true" className="text-2xl">
            ☰
          </span>{" "}
          Menu
        </button>
        <span className="truncate font-semibold">{screen}</span>
      </header>
      <dialog
        ref={menuRef}
        id="pwa-main-menu"
        aria-labelledby="pwa-menu-title"
        className="pwa-menu"
        onClose={() => setIsMenuOpen(false)}
        onClick={(event) => {
          if (event.target === event.currentTarget) menuRef.current?.close();
        }}
      >
        <div className="space-y-6 p-4">
          <div className="flex items-center justify-between gap-3">
            <h2 id="pwa-menu-title" className="text-xl font-semibold">
              Cadendar Mobile
            </h2>
            <button
              type="button"
              autoFocus
              aria-label="Fermer le menu principal"
              className="min-h-11 min-w-11 rounded border border-slate-300 text-xl"
              onClick={() => menuRef.current?.close()}
            >
              ×
            </button>
          </div>
          <nav aria-label="Navigation principale" className="space-y-2">
            {screens.map((item) => (
              <button
                key={item}
                type="button"
                aria-current={screen === item ? "page" : undefined}
                className={`min-h-14 w-full rounded-lg px-4 py-3 text-left ${screen === item ? "bg-blue-100 font-semibold text-blue-900" : "hover:bg-slate-100"}`}
                onClick={() => selectScreen(item)}
              >
                {item}
              </button>
            ))}
          </nav>
        </div>
      </dialog>
      <div hidden={screen !== "Agenda"}>
        <AgendaMainScreen />
      </div>
      {screen === "Checklists" && <ChecklistsScreen userId={userId} />}
      {hasOpenedReception && (
        <div hidden={screen !== "Réception des commandes"}>
          <OrdersReceptionScreen
            api={ordersApi}
            isActive={screen === "Réception des commandes"}
          />
        </div>
      )}
    </div>
  );
};

export default ScreenSwitcher;
